import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DescriptionRow, Money } from 'components';
import { TranslationNamespace } from 'i18n';
import { P2PProviderPayinConfig, P2PProviderPayoutConfig } from 'types';

type Props = {
  fiatCurrencyId: string;
  config?: P2PProviderPayinConfig | P2PProviderPayoutConfig;
};

export const P2PProviderOrderAmountLimitsDetails: React.FC<Props> = ({
  fiatCurrencyId,
  config,
}) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.p2p_providers',
  });

  return config ? (
    <DescriptionRow
      title={t('details.order_amount_limits')}
      value={
        <Stack direction="row" spacing={1}>
          {config.orderMinAmount ? (
            <Money
              value={config.orderMinAmount}
              fiatCurrencyId={fiatCurrencyId}
              symbol
            />
          ) : (
            '-'
          )}
          <span>{'/'}</span>
          {config.orderMaxAmount ? (
            <Money
              value={config.orderMaxAmount}
              fiatCurrencyId={fiatCurrencyId}
              symbol
            />
          ) : (
            '-'
          )}
        </Stack>
      }
    />
  ) : null;
};
